import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fc4f0ef0")

_pushScopeId("data-v-fc4f0ef0")
const _hoisted_1 = /*#__PURE__*/_createVNode("svg", {
  class: "shaka-big-play",
  viewBox: "0 0 61 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("rect", {
    width: "61",
    height: "61",
    rx: "12",
    class: "shaka-play-button-color",
    "fill-opacity": "0.8"
  }),
  /*#__PURE__*/_createVNode("path", {
    class: "shaka-play-button-contrast",
    d: "M22 21.5763C22 19.5799 24.1634 18.3445 25.8688 19.367L40.752 28.2906C42.416 29.2884 42.416 31.7115 40.752 32.7092L25.8688 41.633C24.1635 42.6555 22 41.4201 22 39.4237L22 21.5763Z"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  class: "cont-play-arrow",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M8.00001 8.73444C8.00001 7.13218 9.7458 6.14062 11.1219 6.96127L23.132 14.1234C24.4748 14.9241 24.4748 16.8689 23.132 17.6697L11.1219 24.8319C9.7458 25.6526 8 24.661 8 23.0587L8.00001 8.73444Z",
    class: "play-arrow"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isPosterVisible.value)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "pw-player-playBtn-holder player-adon",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args)))
      }, [
        (!_ctx.isTrailer)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              role: "button",
              "aria-label": `${_ctx.translateLabels('Play')} - ${_ctx.title}`
            }, [
              _hoisted_1
            ], 8, ["aria-label"]))
          : (_openBlock(), _createBlock("button", {
              key: 1,
              type: "button",
              role: "button",
              "aria-label": `${_ctx.translateLabels('Watch Trailer')} - ${_ctx.title}`,
              class: "pw-trailer-play-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args)))
            }, [
              _hoisted_2,
              _createVNode("span", {
                class: "wath-trailer-txt",
                innerHTML: `${_ctx.translateLabels('Watch Trailer')} | ${_ctx.totalDuration}`
              }, null, 8, ["innerHTML"])
            ], 8, ["aria-label"])),
        (_ctx.totalDuration && !_ctx.isTrailer)
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              class: "parmonic-video-duration",
              ref: "duration",
              innerHTML: _ctx.totalDuration
            }, null, 8, ["innerHTML"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})